export default __webpack_public_path__ + "static/media/yellow-fin-tuna.c2a19cc6.png";